import { cx } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { Tooltip } from "src/components/Default/LekUI/Tooltip";
import { isMultiAnswersExam } from "src/helpers/examHelpers";
import isMobile from "src/helpers/isMobile";
import { ExamStatus, ExamTypes } from "src/types/enums";

import { BasicExamType } from "../ExamTypes/BasicExamType";
import { LearningExamType } from "../ExamTypes/LearningExamType";
import { SimulationExamType } from "../ExamTypes/SimulationExamType";
import ExamProgress from "../Progresses/ExamProgress";
import DefaultDetails, { DefaultScore } from "./DefaultDetails";

const ExamType = {
	[ExamTypes.SIMULATION]: SimulationExamType,
	[ExamTypes.LEARNING]: LearningExamType,
	[ExamTypes.BASIC]: BasicExamType,
	[ExamTypes.COURSE]: BasicExamType,
};

export default function ExamDetails({ row, className }) {
	const { t } = useTranslation();
	const ExamTypeComponent = ExamType[row.type];
	const shouldShowScore =
		row.status === ExamStatus.FINISHED || !isMultiAnswersExam(row.type);
	const title = isMobile()
		? t("defaultsText.score")
		: t("defaultsText.yoursScore");

	if (!row.type) {
		return null;
	}

	return (
		<DefaultDetails
			className={className}
			title={row.name}
			Score={() => (
				<div className="flex items-center justify-start gap-8">
					<DefaultScore
						title={
							<div className="flex gap-4">
								<span>{title}: </span>
								<Tooltip
									title={
										shouldShowScore
											? ""
											: "Wynik zostanie zaprezentowany po zakończeniu egzaminu"
									}
								>
									<span
										className={cx({
											blur: !shouldShowScore,
											"cursor-pointer": !shouldShowScore,
										})}
									>
										{row.score}%
									</span>
								</Tooltip>
							</div>
						}
					/>
					<ExamTypeComponent row={row} />
				</div>
			)}
			Progress={() => <ExamProgress row={row} />}
		/>
	);
}
